// extracted by mini-css-extract-plugin
export default {"head":"PageHead_head__lMNZF","title":"PageHead_title__HxK+x"};